module.exports = __webpack_public_path__ + "static/media/fresh1.cb24fb3c.png";